import { useState } from "react";
import { sprache, t } from "../i18n/index.js";
import { REIHENFOLGE, WITTERUNG_INDEX, infoTexte } from "./info-texte.js";

/* ================================================================
   Info — Rückmeldung und Einführung.

   Der erste Abschnitt nennt die Adresse für Rückmeldungen, danach
   folgt eine Einführung in die Funktionen. Die Abschnitte sind
   eingeklappt: Wer nur die Adresse sucht, soll nicht erst scrollen
   müssen; wer sich einarbeitet, klappt der Reihe nach auf.

   Gezeigt wird nur, was das Konto auch nutzen kann — Weinkarten und
   Witterung sind je Nutzer freizuschalten, und eine Anleitung zu
   einer fehlenden Schaltfläche stiftet mehr Verwirrung als Nutzen.

   Die Texte selbst stehen in info-texte.js, je Sprache.
   ================================================================ */

const KONTAKT = "winelake@outlook.de";

function abschnitte({ darfWeinkarten, darfWetter, istCloud }, code) {
  const texte = infoTexte(code);
  const liste = [];
  for (const name of REIHENFOLGE) {
    if (name === "teilen" && !darfWeinkarten) continue;
    if (name === "katalog" && !istCloud) continue;
    const a = texte[name];
    if (!a) continue;
    let punkte = a.punkte;
    /* Ohne freigeschaltete Witterung fällt der entsprechende Punkt weg. */
    if (name === "daten" && !darfWetter) punkte = punkte.filter((_, i) => i !== WITTERUNG_INDEX);
    liste.push({ name, titel: a.titel, absatz: a.absatz, punkte });
  }
  return liste;
}

function InfoPanel({ nutzer, istCloud }) {
  const code = sprache();
  const teile = abschnitte({
    darfWeinkarten: !!(nutzer && nutzer.darfWeinkarten),
    darfWetter: !!(nutzer && nutzer.darfWetter),
    istCloud: !!istCloud,
  }, code);
  /* Alles zu beim Öffnen: Wer nur die Adresse für Rückmeldungen
     sucht, soll nicht an einem aufgeklappten Kapitel vorbeiscrollen
     müssen — und wer sich einarbeitet, sieht zuerst die vollständige
     Übersicht der Themen. */
  const [offen, setOffen] = useState(null);

  return (
    <div className="wl-info">
      <section className="wl-info-kontakt">
        <span className="wl-konto-titel">{t("Rückmeldung")}</span>
        <p className="wl-fliesstext">
          {t("Fehler gefunden, etwas vermisst oder eine Idee? Schreib mir gern — jede Rückmeldung hilft.")}
        </p>
        <a className="wl-info-mail" href={`mailto:${KONTAKT}`}>{KONTAKT}</a>
      </section>

      <div className="wl-teil-trenner" />
      <span className="wl-konto-titel">{t("Einführung")}</span>
      <p className="wl-fliesstext">
        {t("Ein Überblick über die wichtigsten Funktionen. Die Abschnitte lassen sich einzeln aufklappen.")}
      </p>

      <ul className="wl-info-liste">
        {teile.map((a) => {
          const auf = offen === a.name;
          return (
            <li key={a.name} className="wl-info-abschnitt">
              <button className="wl-info-kopf" aria-expanded={auf}
                onClick={() => setOffen(auf ? null : a.name)}>
                <span className="wl-karte-pfeil" aria-hidden="true">{auf ? "▾" : "▸"}</span>
                <span className="wl-info-titel">{a.titel}</span>
              </button>
              {auf && (
                <div className="wl-info-inhalt">
                  <p className="wl-fliesstext">{a.absatz}</p>
                  <dl className="wl-info-punkte">
                    {a.punkte.map(([begriff, text]) => (
                      <div key={begriff} className="wl-info-punkt">
                        <dt>{begriff}</dt>
                        <dd>{text}</dd>
                      </div>
                    ))}
                  </dl>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export { InfoPanel, KONTAKT };
